export const ADD_WHITE_BOARD = 'ADD_WHITE_BOARD'
export const REMOVE_WHITE_BOARD = 'REMOVE_WHITE_BOARD'
export const NEW_ACTIVE_WHITE_BOARD = 'NEW_ACTIVE_WHITE_BOARD'